<script lang="ts">
  import Text from "../../components/Text.svelte"
  import Title2 from "../../components/Title2.svelte"
  import ServiceCard from "./ServiceCard.svelte"
  import { services } from "./services"
</script>

<section>
  <Title2 class="services-title">Additional Dental Implant Services</Title2>
  <Text center class="services-text"
    >At ClearChoice, we know your smile is as unique as you are. That’s why
    we’re proud to offer completely customized treatment plans tailored to meet
    your lifestyle and budget needs. Ask about our third party financing
    options to help make treatment more affordable.</Text
  >
  <div>
    {#each services as service}
      <ServiceCard {...service} />
    {/each}
  </div>
</section>

<style lang="scss">
  section {
    padding: 40px 20px;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  :global(.services-title) {
    margin-bottom: 16px !important;
  }

  :global(.services-text) {
    margin-bottom: 32px !important;
  }

  @media (min-width: 768px) {
    section {
      padding: 60px 5%;
    }

    div {
      flex-direction: row;
      gap: 12px;
    }

    :global(.services-title) {
      margin-bottom: 12px !important;
    }

    :global(.services-text) {
      margin-bottom: 40px !important;
    }
  }
</style>
